import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../pages/Results/Results.scss';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';

const ResultsMoreInfo = ({ resetForm, goBack }) => {
  const locId = useContext(LocaleContext);
  const topOfResultsPage = useRef();

  const removeFocus = () => {
    const heading = document.getElementById('heading-no-focus');
    heading.removeAttribute('tabIndex');
  };

  useEffect(() => {
    topOfResultsPage.current.focus();
    setTimeout(removeFocus, 1000);
  }, []);

  return (
    <div className="pass-message" data-testid="results-more-info">
      <h1 id="heading-no-focus" ref={topOfResultsPage} tabIndex="-1">
        {getText(locId, 'Results', 'header', 'ResultsMoreInfo')}
      </h1>
      <p>{getText(locId, 'Results', 'paragraph', 'ResultsMoreInfo')}</p>

      <div className="final-nav top-buttons">
        <button
          type="button"
          id="results-back-button"
          className="button button-secondary results-back-button"
          onClick={goBack}
        >
          {getText(locId, 'AllPages', 'backButton')}
        </button>
        <button
          type="button"
          id="results-start-over-button"
          className="button button-primary results-start-over-button"
          onClick={resetForm}
        >
          {getText(locId, 'Results', 'startOverButton')}
        </button>
      </div>
    </div>
  );
};

ResultsMoreInfo.propTypes = {
  goBack: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
};

export default ResultsMoreInfo;
